import { snakeCase } from 'lodash';

/**
 * Object of operators and their data checks.
 */
export const filterOperators = {
  eq: (a, b, nullCheck = true) => (nullCheck ? (b === 'null' ? a == null : a == b) : a == b),
  neq: (a, b, nullCheck = true) => (nullCheck ? (b === 'null' ? a != null : a != b) : a != b),
  lt: (a, b) => a != null && b != null && a < b,
  lte: (a, b) => a != null && b != null && a <= b,
  gt: (a, b) => a != null && b != null && a > b,
  gte: (a, b) => a != null && b != null && a >= b,
  like: (a, b) =>
    (typeof a === 'string' || typeof a === 'number') && a.toString().includes(b.toString()),
  ilike: (a, b) =>
    (typeof a === 'string' || typeof a === 'number') &&
    a.toString().toLowerCase().includes(b.toString().toLowerCase()),
  any: (a, b) => toArray(a).some((elementA) => toArray(b).some((elementB) => elementA == elementB)),
};

/**
 * Function that transforms filter fields to parsed data.
 *
 * @param field (string) in camel case of the filter field.
 * @returns array of the root field and nested field in snake case.
 */
export const getRootAndNestedFields = (field: string): [string, string | undefined] => {
  const fieldParts = field.split('.');
  // zone --> zone_name: to keep parity with MVT snake case properties
  const rootField = fieldParts[0] === 'zone' ? 'zone_name' : snakeCase(fieldParts[0]);
  const nestedField = fieldParts[1] ? snakeCase(fieldParts[1]) : undefined;

  return [rootField, nestedField];
};

/**
 * Function that transforms an input to an array.
 *
 * @param {string | number} input - value to be transformed into an array.
 * @returns array from the input.
 */
const toArray = (input) => {
  if (Array.isArray(input)) {
    return input;
  }
  if (typeof input === 'string') {
    return input.split(',');
  }
  if (typeof input === 'number') {
    return [input];
  }
  return [];
};

/**
 * Date Comment Added: 06/28/2024
 *
 * Pulled from ColumnSearchFilter.tsx as it was unused.
 * Leaving it here to keep inventory of the function for future possible use.
 *
 */

// const mapFormFiltersToNewFormat = (filterState): FilterRepresentation => {
//   const filterMap: FilterRepresentation = {};
//   const filters = filterState.filters.filter((d) => d.field !== null);
//   if (filters.length > 0 && filterState.logicalOperator !== 'and') {
//     filterMap['joinBy'] = filterState.logicalOperator;
//   }

//   filters.forEach((filter) => {
//     const hasEmptyOperator = ['is empty', 'is not empty'].some(
//       (e) => e === filter.comparisonOperator
//     );

//     if (filter.field === null) return;
//     if (filter.value === null && !hasEmptyOperator) return;

//     if (filter.field in filterMap) {
//       if (filter.comparisonOperator === 'is any of') {
//         filterMap[filter.field].push({
//           operator: operatorMap[filter.comparisonOperator],
//           value: filter.value.join(','),
//         });
//       } else if (hasEmptyOperator) {
//         filterMap[filter.field].push({
//           operator: operatorMap[filter.comparisonOperator],
//           value: 'null',
//         });
//       } else {
//         filter.value.forEach((val) => {
//           filterMap[filter.field].push({
//             operator: operatorMap[filter.comparisonOperator],
//             value: val,
//           });
//         });
//       }
//     } else {
//       if (filter.comparisonOperator === 'is any of') {
//         filterMap[filter.field] = [
//           {
//             operator: operatorMap[filter.comparisonOperator],
//             value: filter.value.join(','),
//           },
//         ];
//       } else if (hasEmptyOperator) {
//         filterMap[filter.field] = [
//           {
//             operator: operatorMap[filter.comparisonOperator],
//             value: 'null',
//           },
//         ];
//       } else {
//         filterMap[filter.field] = filter.value.map((val) => {
//           return {
//             operator: operatorMap[filter.comparisonOperator],
//             value: val,
//           };
//         });
//       }
//     }
//   });

//   return filterMap;
// };
